import {
  Center,
  Container,
  Grid,
  Spinner,
  Square,
  useColorMode,
} from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { IoMdPause, IoMdPlay } from "react-icons/io";
import { useAudioPlayer } from "react-use-audio-player";

interface AudioPlayerProps {
  file: string;
  uuid: string;
  title: string;
  onOpen: () => void;
}

const AudioPlayer = ({ file }: AudioPlayerProps) => {
  const { togglePlayPause, ready, loading, playing } = useAudioPlayer({
    src: file,
    format: "mp3",
    preload: "none",
    autoplay: true,
    html5: false,
    onend: () => console.log("sound has ended!"),
  });
  const [isPlaying, setIsPlaying] = useState(false);
  const { colorMode } = useColorMode();

  useEffect(() => {
    setIsPlaying(playing);
  }, [playing]);

  if (!file) return;
  if (!ready && !loading) return <div>Audio not ready</div>;
  if (loading)
    return (
      <div>
        <Container maxW={900} maxH={40} mt={5} mb={5}>
          <Grid templateColumns="repeat(3, 1fr)" gap={6} alignItems="center">
            <Center></Center>
            <Center>
              <div style={{ minWidth: 68 }}>
                <Spinner size={"md"} mt={"13px"} mb={0} thickness="3px" />
              </div>
            </Center>
            <Center></Center>
          </Grid>
        </Container>
      </div>
    );

  return (
    <div>
      <Container maxW={900} maxH={40}>
        <Grid templateColumns="repeat(3, 1fr)" gap={6} alignItems="center">
          <Center></Center>
          <Center>
            <button onClick={togglePlayPause}>
              <Square maxW={70} padding={5} marginTop={2} marginBottom={2}>
                {isPlaying ? (
                  <IoMdPause
                    size={28}
                    color={colorMode === "dark" ? "white" : "black"}
                  />
                ) : (
                  <IoMdPlay
                    size={28}
                    color={colorMode === "dark" ? "white" : "black"}
                  />
                )}
              </Square>
            </button>
          </Center>
          <Center></Center>
        </Grid>
      </Container>
    </div>
  );
};

export default AudioPlayer;
